import fetcher from './fetcher';
export default function getBookingPrices({ paymentModality, paymentMethod, bookingId }) {
    return fetcher({
        url: `/api/v1/currencies/all-booking-prices/${bookingId}?modality=${paymentModality}&${paymentMethod ? `method=${paymentMethod}` : ''}`,
        method: 'GET'
    });
}
